import { evalAuthHeaders, getEvalBase } from '../../evalApiBase'
import {
  buildGoldenPromptsListQuery,
  GoldenPrompt,
  GoldenPromptCreateInput,
  GoldenPromptFilters,
  GoldenPromptListResponse,
  GoldenPromptUpdateInput,
  GoldenPromptUploadResponse,
  MutationStatusResponse,
} from './goldenPromptsAdminModel'

export async function listGoldenPromptsAdmin(
  filters: GoldenPromptFilters,
): Promise<GoldenPromptListResponse> {
  const query = buildGoldenPromptsListQuery(filters)
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts?${query}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Golden prompts list failed: ${res.status}`)
  }
  return res.json()
}

export async function getGoldenPromptAdmin(promptId: string): Promise<GoldenPrompt> {
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts/${promptId}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Golden prompt fetch failed: ${res.status}`)
  }
  return res.json()
}

export async function createGoldenPromptAdmin(
  input: GoldenPromptCreateInput,
): Promise<GoldenPrompt> {
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts`, {
    method: 'POST',
    headers: { ...evalAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  if (!res.ok) {
    throw new Error(`Golden prompt create failed: ${res.status}`)
  }
  return res.json()
}

export async function updateGoldenPromptAdmin(
  promptId: string,
  input: GoldenPromptUpdateInput,
): Promise<GoldenPrompt> {
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts/${promptId}`, {
    method: 'PATCH',
    headers: { ...evalAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  if (!res.ok) {
    throw new Error(`Golden prompt update failed: ${res.status}`)
  }
  return res.json()
}

export async function uploadGoldenPromptsAdmin(
  file: File,
): Promise<GoldenPromptUploadResponse> {
  const formData = new FormData()
  formData.append('file', file)
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts/upload`, {
    method: 'POST',
    headers: evalAuthHeaders(),
    body: formData,
  })
  if (!res.ok) {
    const detail = await readErrorDetail(res)
    throw new Error(detail || `Golden prompts upload failed: ${res.status}`)
  }
  return res.json()
}

async function readErrorDetail(res: Response): Promise<string | null> {
  try {
    const body = await res.json()
    if (body && typeof body.detail === 'string') {
      return body.detail
    }
  } catch {
    // fall through
  }
  return null
}

export async function getMutationStatusAdmin(
  promptId: string,
): Promise<MutationStatusResponse> {
  const res = await fetch(
    `${getEvalBase()}/v1/golden-prompts/${promptId}/mutations`,
    { headers: evalAuthHeaders() },
  )
  if (!res.ok) {
    throw new Error(`Mutation status fetch failed: ${res.status}`)
  }
  return res.json()
}

export async function enqueueMutationAdmin(
  promptId: string,
): Promise<MutationStatusResponse> {
  const res = await fetch(
    `${getEvalBase()}/v1/golden-prompts/${promptId}/mutations`,
    { method: 'POST', headers: evalAuthHeaders() },
  )
  if (!res.ok) {
    throw new Error(`Mutation enqueue failed: ${res.status}`)
  }
  return res.json()
}

export async function deleteGoldenPromptAdmin(promptId: string): Promise<void> {
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts/${promptId}`, {
    method: 'DELETE',
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Golden prompt delete failed: ${res.status}`)
  }
}
